<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/preloader";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Factory Stock Movement",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Factory Stock Movement Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Stock Movement",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      totals: {
        total_in: 0,
        total_out: 0,
        total_balance: 0,
      },
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "typename",
          sortable: true,
          label: "TYPE",
        },
        {
          key: "customer",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "from_quantity",
          sortable: true,
          label: "OLD QUANTITY",
        },
        {
          key: "qty_in",
          sortable: true,
          label: "QUANTITY IN",
        },
        {
          key: "qty_out",
          sortable: true,
          label: "QUANTITY OUT",
        },
        {
          key: "balance",
          sortable: true,
          label: "NEW QUANTITY",
        },
        {
          key: "user",
          sortable: true,
          label: "MADE BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "date_recorded",
          sortable: true,
          label: "RECORDED ON",
        },
      ],
      data: {
        batch: atob(this.$route.params.batch),
        category: '2',
      },
    };
  },

  computed: {
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("factorystock", ["StockMovement", "FilterStatus"]),


    /**
     * Total no. of records
     */

    rows() {
      return this.StockMovement ? this.StockMovement.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StockMovement ? this.StockMovement.length : 1;
  },
  methods: {
    ...mapActions({
      FetchMovements: "factorystock/fetchStockMovements"
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filterReport() {
      this.FetchMovements(this.data);
    },
  },
  updated() {
    if (this.StockMovement) {
      let total_in = 0;
      let total_out = 0;
      this.StockMovement.forEach((item) => {
        total_in = total_in + parseInt(item.qty_in);
        total_out = total_out + parseInt(item.qty_out);
      });
      this.totals.total_in = total_in;
      this.totals.total_out = total_out;
      this.totals.total_balance = total_in - total_out;
    }
  },

  created() {
    this.FetchMovements(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card" v-if="!FilterStatus">
          <div class="card-body">
            <div class="row py-3">
              <div class="col-md-10 text-center">
                <h4>
                  <center>Factory {{ StockMovement[0].factoryname }} Stock Movements Report for batch - ({{
                    StockMovement[0].batch }})
                  </center>
                </h4>
              </div>
              <div class="col-md-2 mt-2 ms-auto">
                <button @click="$router.go(-1)" class="btn btn-primary btn-sm">
                  <i class="fas fa-arrow-circle-left"></i> Go Back
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="StockMovement ? StockMovement : []" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(mode_field)="data">
                  {{ data.item.mode.name }} ({{ data.item.mode.type_name }}-{{ data.item.mode.account_number }})
                </template>
              </b-table>
              <div class="row">
                <div class="col-md-4">
                  <h5>Total Qty In: <span class="text-danger">{{ (totals.total_in).toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-4">
                  <h5>Total Qty Out: <span class="text-danger">{{ (totals.total_out).toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-4">
                  <h5>Total Balance: <span class="text-danger">{{ (totals.total_balance).toLocaleString() }}</span></h5>
                </div>
              </div>
            </div>            
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loader v-if="FilterStatus" />
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>
